const regex = new RegExp('^-?([1-8]?[1-9]|[1-9]0)\\.{1}\\d{1,6}');

const coordinatesValidation = (coordinates) => {
  if (coordinates !== null) {
    if (regex.test(coordinates)) {
      return true;
    }
  }
  return false;
};

export default coordinatesValidation;
